import { createSlice } from "@reduxjs/toolkit";

export const intialUserLocalState = {
  name: "",
  email: "",
  phone: "",
  role: "",
};

const initialState = {
  users: [],
  userDetail: null,
  newUserLocal: intialUserLocalState,
  userRoles: [],
  staffPagination: {},
  isAddSubUserSuccess: false,
  isUpdateSubUserSuccess: false,
  isDeleteResponseSuccess: false,
  isUserResetPasswordSuccess: false,
  isConfirmationEmailSuccess: false,
};

export const subUserSlice = createSlice({
  name: "subUser",
  initialState,
  reducers: {
    getAllSubUserAction: (state, { payload }) => {},
    setAllSubUserAction: (state, { payload }) => {
      const { pagination = { currentPage: 1 }, list = [] } = payload;
      state.users = payload?.list;
      state.staffPagination = pagination;
    },

    getAllUserRolesAction: (state) => {},
    setAllUserRolesAction: (state, { payload }) => {
      state.userRoles = payload;
    },

    addSubUserAction: (state, { payload }) => {},
    setAddSubUserResponse: (state, { payload }) => {
      state.isAddSubUserSuccess = payload;
    },

    updateSubUserAction: (state, { payload }) => {},
    updateSubUserResponse: (state, { payload }) => {
      state.isUpdateSubUserSuccess = payload;
    },

    deleteSubUserAction: (state, { payload }) => {},
    setDeleteSubUserResponse: (state, { payload }) => {
      state.isDeleteResponseSuccess = payload;
    },

    activeSubUserAction: (state, { payload }) => {},

    getResetPasswordAction: (state, { payload }) => {},
    setResetPasswordSuccessAction: (state, { payload }) => {
      state.isUserResetPasswordSuccess = payload;
    },

    setNewSubUserLocal: (state, action) => {
      state.newUserLocal = action.payload;
    },
    resetNewSubUserLocal: (state) => {
      state.newUserLocal = intialUserLocalState;
    },

    setStaffConfirmationEmailAction: (state, { payload }) => {},
    setConfirmationEmailSuccessAction: (state, { payload }) => {
      state.isConfirmationEmailSuccess = payload;
    },
  },
});

const {
  getAllSubUserAction,
  setAllSubUserAction,
  getAllUserRolesAction,
  setAllUserRolesAction,
  addSubUserAction,
  setAddSubUserResponse,
  updateSubUserAction,
  updateSubUserResponse,
  setNewSubUserLocal,
  resetNewSubUserLocal,
  deleteSubUserAction,
  setDeleteSubUserResponse,
  getResetPasswordAction,
  setResetPasswordSuccessAction,
  activeSubUserAction,
  setStaffConfirmationEmailAction,
  setConfirmationEmailSuccessAction,
} = subUserSlice.actions;

export {
  getAllSubUserAction,
  setAllSubUserAction,
  getAllUserRolesAction,
  setAllUserRolesAction,
  addSubUserAction,
  setAddSubUserResponse,
  updateSubUserAction,
  updateSubUserResponse,
  setNewSubUserLocal,
  resetNewSubUserLocal,
  deleteSubUserAction,
  setDeleteSubUserResponse,
  getResetPasswordAction,
  setResetPasswordSuccessAction,
  activeSubUserAction,
  setStaffConfirmationEmailAction,
  setConfirmationEmailSuccessAction,
};

export default subUserSlice.reducer;
